const classrooms = {
	title: "Classrooms",
	new_classroom: "New Classroom",
	edit_classroom: "Edit Classroom: {name}",
	view_classroom: "View Classroom: {name}",
	list_title: "List of Classrooms",
	list_subtitle: "Manage Classroom",
	create_title: "Create New Classroom",
	update_title: "Update Classroom",
	address_title: "Address",
	details_title: "Classroom Details",
	id: "ID",
	name: "Name",
	address_id: "Address",
	place: "Place",
	created_by: "Created By",
	status: "Status",
};
export default classrooms;